const C = { roy: '#85BB65', royDark: '#5E9444', bg: '#F0F2F0', surface: '#FAFBFA', border: '#E8EBE8', text: '#1A1E1A', text2: '#4A5248', text3: '#8A948A' };

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 40 }}>
      <h2 style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800, fontSize: 20, color: C.text, marginBottom: 12, marginTop: 0 }}>{title}</h2>
      <div style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 14, color: C.text2, lineHeight: 1.85 }}>{children}</div>
    </div>
  );
}

export default function Privacy() {
  return (
    <div style={{ paddingTop: 64, background: C.surface, minHeight: '100vh' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '60px 24px 96px' }}>
        <p style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 11, color: C.roy, letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 12 }}>Legal</p>
        <h1 style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 900, fontSize: 'clamp(32px, 5vw, 52px)', color: C.text, marginBottom: 12, marginTop: 0, letterSpacing: '-0.025em' }}>Privacy Policy</h1>
        <p style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 13, color: C.text3, marginBottom: 48 }}>Last updated: January 2026</p>

        <Section title="1. Who we are">
          Korunto is a loyalty platform operated in the United Kingdom. We enable customers to earn and spend loyalty points across participating vendor businesses. Our contact email is <a href="mailto:hello@korunto.com" style={{ color: C.royDark }}>hello@korunto.com</a>.
        </Section>

        <Section title="2. What data we collect">
          <p style={{ marginTop: 0 }}>When you create a Korunto account, we collect:</p>
          <ul style={{ paddingLeft: 20, marginTop: 8 }}>
            <li>Your name and email address</li>
            <li>A hashed password (we never store your password in plain text)</li>
            <li>A blockchain wallet address generated for your account</li>
            <li>Transaction history (points earned, redeemed, and exchanged)</li>
          </ul>
          <p>For vendors, we also collect business name, business type, phone number, and Companies House information where provided.</p>
        </Section>

        <Section title="3. How we use your data">
          <p style={{ marginTop: 0 }}>We use your data to:</p>
          <ul style={{ paddingLeft: 20, marginTop: 8 }}>
            <li>Operate your Korunto account and track your loyalty points</li>
            <li>Send transactional emails (point confirmations, stamp card rewards)</li>
            <li>Enable vendors to award points to your account</li>
            <li>Comply with legal and regulatory obligations</li>
          </ul>
          <p>We do not sell your data to third parties. We do not use your data for advertising.</p>
        </Section>

        <Section title="4. How your points are stored">
          Your loyalty points are secured using distributed ledger technology, which ensures your points cannot be altered, deleted, or manipulated by any single party — including Korunto. Your points balance is independently verifiable and protected even if Korunto ceases to operate. No personal information is attached to your points record in this system.
        </Section>

        <Section title="5. Data retention">
          We retain your account data for as long as your account is active. If you request deletion of your account, we will delete your personal data within 30 days, except where we are required to retain it by law. Note that on-chain transaction records cannot be deleted due to the nature of blockchain technology.
        </Section>

        <Section title="6. Your rights">
          <p style={{ marginTop: 0 }}>Under UK GDPR, you have the right to:</p>
          <ul style={{ paddingLeft: 20, marginTop: 8 }}>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and personal data</li>
            <li>Object to processing of your data</li>
            <li>Lodge a complaint with the ICO (ico.org.uk)</li>
          </ul>
          <p>To exercise any of these rights, email us at <a href="mailto:hello@korunto.com" style={{ color: C.royDark }}>hello@korunto.com</a>.</p>
        </Section>

        <Section title="7. Cookies">
          We use only essential cookies required to keep you logged in. We do not use tracking or advertising cookies.
        </Section>

        <Section title="8. Changes to this policy">
          We may update this privacy policy from time to time. We will notify you of significant changes by email. Continued use of Korunto after changes constitutes acceptance of the updated policy.
        </Section>

        <Section title="9. Contact">
          For any privacy-related questions, contact us at <a href="mailto:hello@korunto.com" style={{ color: C.royDark }}>hello@korunto.com</a>.
        </Section>
      </div>
    </div>
  );
}
